var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studentMessageHome"},[_c('div',{staticClass:"navBox"},[_c('div',{staticClass:"navRight"},[_c('ul',{staticStyle:{"width":"350px"}},_vm._l((_vm.navRight),function(item,index){return _c('router-link',{key:index,attrs:{"tag":"li","to":item.path}},[_vm._v(_vm._s(item.name))])}),1)])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }